/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext, useContext } from 'react';
import { Offer, OfferOrigins, TiersOfferOrigins } from '../hooks';

const offers: Array<Offer> = [];
const offerOrigins: Array<OfferOrigins> = [];
const offerDataLoaded = false;
const getTiersCurrentOffer = (tiersId: number): Promise<Offer | undefined> =>
    Promise.resolve(undefined);
const getTiersCurrentOfferWithDefault = (tiersId: number): Promise<Offer | undefined> =>
    Promise.resolve(undefined);
const setTiersCurrentOffer = (
    tiersId: number,
    newOfferId?: number,
): Promise<TiersOfferOrigins | undefined> => Promise.resolve(undefined);

const OfferContext = createContext({
    offers,
    offerOrigins,
    offerDataLoaded,
    getTiersCurrentOffer,
    getTiersCurrentOfferWithDefault,
    setTiersCurrentOffer,
});

export const useOfferContext = () => useContext(OfferContext);

export default OfferContext;
